
import { each } from "async";
import * as userUtil from '../user/util';
import * as React from "react";
import moment from 'moment';
import { sortBy, clone } from "lodash";
import { getDateFormat } from "../../util";
import MaterialAvatar from "../../components/general/MaterialAvatar";
import { INotificationMessage } from "../../typings/notifications";

// Check for filter critical data in the comment before
// check if it matches our filters
function isCommentValid(comment: api.Comment) {
    if (comment === undefined) return false;

    if (comment.slug === undefined) return false;
    if (comment.userID === undefined) return false;
    if (comment.groupID === undefined) return false;
    if (comment.rating === undefined) return false;

    return true;
}

export function searchComments(slug: string, userID: string, groupID: string, rating: string, commentSet: api.Comment[]): api.Comment[] {
    let commentsFound = [];

    each(commentSet, _comment => {

        let comment = clone(_comment);

        if (isCommentValid(comment)) {
            if (
                ((slug) && slug === comment.slug || !slug) &&
                ((userID) && userID === comment.userID || !userID) &&
                ((groupID) && groupID === comment.groupID || !groupID) &&
                ((rating) && rating === comment.rating || !rating)
            ) {
                // Inject our moment time object
                comment.momentCreated = moment(comment.created);

                commentsFound.push(comment);
            }
        }
    });

    // Return a sorted version of this array
    return sortBy(commentsFound, 'momentCreated') as api.Comment[];
}

export function orderNotifications(data: INotificationMessage[]): INotificationMessage[] {

    // Work with a clone of the data to help MOBX process it

    if (!data) return [];
    if (data.length === 0) return [];

    let notificationSet = [];

    each(data, _entry => {
        // Clone our entry before modifying it
        let entry = clone(_entry);

        entry.created = moment(entry.created);

        notificationSet.push(entry);
    });

    return sortBy(notificationSet, 'created').reverse() as INotificationMessage[];
}

export function formatSingleDate(date: string) {
    const dateFormatter = getDateFormat();

    return moment(date).format(dateFormatter);
}

export function findUserName(userID: string, org: OrgState): string {
    const foundUser = findUser(userID, org);

    if (foundUser === undefined) return '';

    return foundUser.name;
}

export function findUser(userID: string, org: OrgState): User {
    const {
        members
    } = org;

    let foundUser = undefined;

    if (members) {
        for (let i = 0; i < members.length; i++) {
            //@ts-ignore
            if (members[i].id === userID || members[i].userID === userID) {
                foundUser = members[i];
            }
        }
    }

    // If we didn't find a user just return undefined
    if (foundUser === undefined) return {
        userID: userID,
        username: 'John Doe',
        email: 'johndoe@innovationwithin.com',
        name: "John Doe"
    };

    // Generate our avatar now
    return foundUser;
}

export function buildCommentLink(entryID: string, commentID: string): string {
    return `/canvas/comment/${entryID}/${commentID}`;
}

export function buildForwardLink(base: string, orgID: string, groupID: string, cohortID: string): string {
    return `/forward${base}?orgID=${orgID}&groupID=${groupID}&cohortID=${cohortID}`
}

export function findUserRoleColor(userID: string, org: OrgState, team: TeamState, cohort: CohortState) {
    const {
        members
    } = org;

    const instructorColor = '#ffee58';
    const teamMemberColor = '#2e7d32';

    let foundUser = undefined;

    each(members, member => {
        //@ts-ignore
        if (member.id === userID || member.userID === userID) {
            foundUser = member;
        }
    });

    if (foundUser === undefined) return teamMemberColor;

    const foundRoles = userUtil.getRoles(foundUser, team, cohort);

    const isInstructor = userUtil.isInstructor(foundRoles);

    if (isInstructor) return instructorColor;

    return teamMemberColor;
}

export function findUserAvatar(userID: string, org: OrgState, size: number) {
    let foundUser = findUser(userID, org)

    // If we didn't find a user just return undefined
    if (foundUser === undefined) return undefined;

    // Generate our avatar now
    return <MaterialAvatar sx={{ height: size, width: size }} user={foundUser} />;
}
